<template>
<div class="container" :class="{'down': loadType=='down'}">
    <div class="loading-contain">
        <div class="loading"></div>
        <div>{{ $t('common.loadingMsg') }}</div>
    </div>
</div>
</template>

<script>
export default {
    props: {
        loadType: {
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="scss">
.container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 12px;
  z-index: 2000;
  //background: #222125;
  &.down{
    padding-top: 0;
  }
  .loading-contain{
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #888;
    .loading {
      display: inline-block;
      vertical-align: middle;
      margin-right: 12px;
      width: 25px;
      height: 25px;
      background: transparent;
      border-radius: 50%;
      border: 2px solid #888;
      border-color: #888 #888 #888 transparent;
      animation: loading-spin 0.8s linear;
      animation-iteration-count: infinite;
    }
  }
  .bg-modal{
    position: fixed;
    top:0;
    right:0;
    left:0;
    bottom:0;
    opacity: 0.5;
    background: #fff;
    z-index: 1000;
  }
}



@keyframes loading-spin {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>